import { moduleHost } from '../../infrastructure/components/root-module-host';
import { connectOeDataVM, OeDataContext } from './oe-data.context';
import { OeDataPresentation, OeDataPresentationProps } from './oe-data.presentation';
import { OeDataVM } from './oe-data.viewmodel';

const OeDataContainer = connectOeDataVM<OeDataPresentationProps>(OeDataPresentation, vm => ({ vm: vm }));

export const OeData = moduleHost(OeDataVM, OeDataContext, OeDataContainer);
